// extracted by mini-css-extract-plugin
module.exports = {"typing-dots":"typing-dots__2dVrQ","typing-dots__dot":"typing-dots__dot__hqh2c","typing-dots__indicator":"typing-dots__indicator__379kG"};